<template>
  <div>
    <StepTitle hr>Thank You!</StepTitle>
    <b-row class="justify-content-md-center text-center">
      <b-col md="10" lg="8" xl="6"><slot></slot></b-col>
    </b-row>
    <div class="inputs mt-4">
      <b-row class="justify-content-md-center boxes">
        <b-col md="6" lg="4">
          <b-button block @click="startNewSession()" class="btn btn-default btn-account" variant="primary">Start New Session</b-button>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import StepTitle from './StepTitle'

export default {
  name: 'SessionComplete',
  components: {StepTitle},
  computed: {
    ...mapState(['session'])
  },
  methods: {
    startNewSession: function() {
      this.$store.commit('logout')
      this.$router.replace({name: 'session-start'})
    }
  }
}
</script>

<style scoped>

</style>
